var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 3H17V0.5625C17 0.28125 16.7188 0 16.4375 0H14.5625C14.2344 0 14 0.28125 14 0.5625V3H8V0.5625C8 0.28125 7.71875 0 7.4375 0H5.5625C5.23438 0 5 0.28125 5 0.5625V3H2.75C1.48438 3 0.5 4.03125 0.5 5.25V21.75C0.5 23.0156 1.48438 24 2.75 24H19.25C20.4688 24 21.5 23.0156 21.5 21.75V5.25C21.5 4.03125 20.4688 3 19.25 3ZM18.9688 21.75H3.03125C2.84375 21.75 2.75 21.6562 2.75 21.4688V7.5H19.25V21.4688C19.25 21.6562 19.1094 21.75 18.9688 21.75ZM16.4844 12.375C16.6719 12.1406 16.6719 11.8125 16.4844 11.5781L15.4062 10.5C15.2188 10.2656 14.8438 10.2656 14.6094 10.5L9.40625 15.6562L7.34375 13.5938C7.10938 13.3594 6.78125 13.3594 6.54688 13.5938L5.46875 14.625C5.28125 14.8594 5.28125 15.2344 5.46875 15.4219L8.98438 18.9844C9.21875 19.2188 9.59375 19.2188 9.78125 18.9844L16.4844 12.375Z",
    fill: "#93A2BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.84620579.svg";
export { ForwardRef as ReactComponent };